function getName (individual) {
  if (!individual) return ''
  const { firstName, surname, fatherName, grandfatherName } = individual
  const nameParts = [firstName, fatherName, grandfatherName, surname]

  return nameParts.filter(x => x).join(' ')
}
export {
  getName
}



// WEBPACK FOOTER //
// ./src/utils/nameHelpers.js